import { render, staticRenderFns } from "./jycfgTb.vue?vue&type=template&id=0d5f8a48&scoped=true"
import script from "./jycfgTb.vue?vue&type=script&lang=js"
export * from "./jycfgTb.vue?vue&type=script&lang=js"
import style0 from "./jycfgTb.vue?vue&type=style&index=0&id=0d5f8a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f8a48",
  null
  
)

export default component.exports